export default __webpack_public_path__ + "react-assets/deal-iq-logo-white-on-black.svg";